import React from "react";
import { StyledLoadingThumbnail } from "./LoadingThumbnail.styled";

type LoadingThumbnailProps = {
  marginTop?: number;
};

const LoadingThumbnail = ({ marginTop }: LoadingThumbnailProps) => {
  return <StyledLoadingThumbnail $marginTop={marginTop} />;
};

export default LoadingThumbnail;
